import React, { useState } from 'react';
import Popup from '@techsoftware/happay-widgets/Popup';
import Icons from '@techsoftware/happay-widgets/FontIcon';

export default function CutoffTimeIntimation({ disabled }) {
  const [popup, setPopup] = useState(false);
  return (
    <Popup
      id="reschedule-payment-info-popup"
      open={popup}
      border
      popupStyle={{ top: 30, left: 10 }}
      variant="scroll"
      onMouseEnter={disabled ? () => {} : event => setPopup(true)}
      onMouseLeave={disabled ? () => {} : event => setPopup(false)}
      parentElement={
        <Icons
          type="info"
          className={`${
            disabled ? 'disabled-custom-checkbox' : 'primary-color'
          }`}
        />
      }
      pointerPlacement="top-center"
    >
      <div className="padding-16 font-12 body width-275">
      The payment will be processed at 10 a.m. or 4 p.m.
      IST on the scheduled date, depending on when it is approved.
      </div>
    </Popup>
  );
}
